import { Row, Col, Card, CardBody, Label } from 'reactstrap';
import { MappingState } from '../../../features/ingest/ingestSlice';
export default (state: MappingState) => {
    return (
        <>
            <Row className="mb-3">
                <Col>
                    <Label className="tpicap-label">Upload Group</Label>
                    {state.group.name}
                </Col>
                <Col>
                    <Label className="tpicap-label">Upload Type</Label>
                    {state.type.name}
                </Col>
                <Col></Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Label className="tpicap-label">Filename</Label>
                    {state.fileName}
                </Col>
                <Col>
                    <Label className="tpicap-label"># Rows</Label>
                    {state.rows}
                </Col>
                <Col>
                    <Label className="tpicap-label"># Cols</Label>
                    {state.cols}
                </Col>
            </Row>
        </>
    );
}